import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count"]

  toggle() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateUI()
  }

  updateUI() {
    const selected = this.checkboxTargets.filter(cb => cb.checked).length
    const total = this.checkboxTargets.length

    if (selected > 0) {
      this.barTarget.classList.remove("hidden")
      this.barTarget.classList.add("flex")
    } else {
      this.barTarget.classList.add("hidden")
      this.barTarget.classList.remove("flex")
    }

    this.countTarget.textContent = `${selected} selected`

    this.selectAllTarget.checked = selected === total && total > 0
    this.selectAllTarget.indeterminate = selected > 0 && selected < total
  }
}
